import axios from 'axios';
import { ajaxExceptionParser } from '@skunexus/utils';
import { SKUNEXUS_LOGIN_PATH } from '../setup/custom/oktaLogin/constants';

axios.interceptors.response.use(
    (res) => res,
    (e) => ajaxExceptionParser(e, { urls: { login: ['/login', SKUNEXUS_LOGIN_PATH] } }),
);
